'use client';
import Header from'@/components/common/Header';
 import ContactSection from'./ContactSection';
 import AboutSection from'./AboutSection';
 import MissionVisionSection from'./MissionVisionSection';
 import Image from'next/image';
import FooterSection from '../FooterSection';

const ContactPage = () => {
  return (
    <main className="w-full bg-white">
      {/* Header */}
      <Header />

      {/* Contact Form Section */}
      <ContactSection />

      {/* Footer */}
    <FooterSection />
    </main>
  )
}

export default ContactPage